import { isProd } from './isProd'

export const generateCcdExplorerUrl = (category, value) => {
  const baseUrl = isProd
    ? 'https://ccdexplorer.io/mainnet'
    : 'https://ccdexplorer.io/testnet'

  if (category === 'contract') {
    //testnet.ccdscan.io/contracts?dcount=1&dentity=contract&dcontractAddressIndex=8861&dcontractAddressSubIndex=0
    return `${baseUrl}/instance/${value}/0`
  }

  if (category === 'account') {
    return `${baseUrl}/account/${value}`
  }

  // transactions
  return `${baseUrl}/transaction/${value}`
}
